import { render, staticRenderFns } from "./Negociaciones.vue?vue&type=template&id=5459d93a&"
import script from "./Negociaciones.vue?vue&type=script&lang=js&"
export * from "./Negociaciones.vue?vue&type=script&lang=js&"
import style0 from "./Negociaciones.vue?vue&type=style&index=0&id=5459d93a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports